import React from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Stack,
} from "@mui/material";
import ModalCardWithHeaderFooter from "../../../components/Cards/ModalCardWithHeaderFooter";

import {
  blackShade19,
  blueColor04,
  borderTextBoxColor,
  greenStatusColor01,
  greyColor060,
  greyColor53,
  greyColor56,
  lightgreenColor04,
  lightYellowShade01,
  lightYellowShade02,
  oldPriceColor,
  whiteColor,
  yellowShade01,
} from "../../../configs/styles/muiThemes";
import { getDiscountPercentage } from "../../../utils/helper";

function AllSellingProducts({ products }) {
  return (
    <ModalCardWithHeaderFooter title="Top Selling Products" hideFooter>
      <Box sx={styles.tableWrapper}>
        <TableContainer sx={styles.tableContainer} component={Box}>
          <Table>
            <TableHead>
              <TableRow
                sx={{
                  position: "sticky !important",
                  top: 0,
                  zIndex: 20,
                  borderRadius: "8px",
                }}
              >
                <TableCell
                  sx={{ ...styles.tableCell, width: "80%" }}
                  align="center"
                >
                  Product
                </TableCell>
                <TableCell sx={styles.tableCell} align="center">
                  Units sold
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody sx={{ backgroundColor: whiteColor }}>
              {products?.map((product) => (
                <TableRow
                  sx={{
                    borderBottom: `1px solid ${borderTextBoxColor}`,
                    verticalAlign: "top",
                  }}
                  key={product?.id}
                >
                  <TableCell sx={{ ...styles.tableBodyCell, maxWidth: "80%" }}>
                    <Box display="flex" gap="12px">
                      <Box
                        component="img"
                        src={product?.productInfo?.productPhoto?.docURL}
                        sx={{
                          maxWidth: "40px",
                          height: "40px",
                          p: "5px",
                          border: "1px solid #e5e9f0",
                          borderRadius: "5px",
                        }}
                      />
                      <Stack gap="2px">
                        <Typography
                          sx={{
                            wordBreak: "break-word",
                            whiteSpace: "normal",
                            fontSize: 12,
                            fontWeight: 600,
                            color: blackShade19,
                            lineHeight: "16px",
                          }}
                        >
                          {product?.productName}
                        </Typography>
                        <Box display={"flex"} alignItems="center">
                          <Typography
                            variant="body1"
                            color={oldPriceColor}
                            fontSize={11}
                            lineHeight="15px"
                            fontWeight={400}
                            mt={{ xs: "0px !important", md: "7px !important" }}
                            sx={{
                              textDecoration: "line-through",
                              display: "inline",
                            }}
                          >
                            {product?.productInfo?.productOriginalPrice ===
                            product?.productInfo?.productSalePrice
                              ? ""
                              : `₹${product?.productInfo?.productOriginalPrice}`}
                          </Typography>

                          <Typography
                            variant="body1"
                            color={blueColor04}
                            fontSize={12}
                            lineHeight="15px"
                            fontWeight={600}
                            m="6px 0 0 0px"
                            sx={{
                              display: "inline",
                              ml:
                                product?.productInfo?.productOriginalPrice ===
                                product?.productInfo?.productSalePrice
                                  ? 0
                                  : 1,
                              mr: 1,
                            }}
                          >
                            ₹{product?.productInfo?.productSalePrice}
                          </Typography>
                          {product?.productInfo?.productOriginalPrice !==
                          product?.productInfo?.productSalePrice ? (
                            <Box sx={styles.statusBoxChip}>
                              <Typography
                                color={yellowShade01}
                                fontSize="11px"
                                fontWeight={600}
                                lineHeight={1}
                                margin={0}
                              >
                                {getDiscountPercentage(
                                  product?.productInfo?.productSalePrice,
                                  product?.productInfo?.productOriginalPrice
                                )}
                                %
                                {/* {Math.round(calculatePercentageOff(item?.productOriginalPrice, item?.productSalePrice))}% */}
                              </Typography>
                            </Box>
                          ) : null}
                        </Box>
                      </Stack>
                    </Box>
                  </TableCell>
                  <TableCell sx={styles.tableBodyCell}>
                    <Box
                      sx={{
                        fontWeight: 500,
                        fontSize: "12px",
                        color: greenStatusColor01,
                        textAlign: "center",
                        background: lightgreenColor04,
                        padding: "2px 4px",
                        width: "40px",
                        borderRadius: "4px",
                        mt: "4px",
                      }}
                    >
                      {product?.totalQuantity}
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </ModalCardWithHeaderFooter>
  );
}

export default AllSellingProducts;

const styles = {
  tableWrapper: {
    width: "100%",
    border: `2.5px solid ${greyColor56}`,
    borderBottom: "none",
    overflow: "hidden",
    borderRadius: "12px",
  },

  tableContainer: {
    maxWidth: "100%",
    borderRadius: "12px",
    overflowY: "scroll",
    maxHeight: "55vh",
    maxWidth: "100%",
    "&::-webkit-scrollbar": {
      width: "4px",
      height: "4px",
      borderRadius: "50px !important",
    },
    "&::-webkit-scrollbar-thumb": {
      // background: '#d0d3da',
      background: "rgba(0,0,0,0.1)",
    },
    "&::-webkit-scrollbar-track": {
      background: "rgba(0,0,0,0.05)",
    },
  },

  tableCell: {
    color: greyColor060,
    fontSize: "12px",
    fontWeight: "400",
    lineHeight: "16px",
    whiteSpace: "nowrap",
    padding: "8px 15px",
    backgroundColor: greyColor53,
    textAlign: "start",
    // borderRight: `1px solid ${whiteColor}`,
  },

  tableBodyCell: {
    fontSize: 12,
    fontWeight: 600,
    lineHeight: "16px",
    whiteSpace: "nowrap",
    color: blackShade19,
    padding: "10px 15px !important",
    textAlign: "start",
  },

  statusBoxChip: {
    backgroundColor: lightYellowShade01,
    border: "1px solid" + lightYellowShade02,
    borderRadius: "4px",
    width: "max-content",
    p: "0 4px",
    display: "flex",
    alignItems: "center",
    height: "20px",
  },
};
